export default [
  {
    title: 'Inicio',
    element: '#home',
  },
  {
    title: 'Nosotros',
    element: '#about-us'
  },
  {
    title: 'Servicios',
    element: '#services'
  },
  {
    title: 'Contacto',
    element: '#contact'
  },
]
